export default __webpack_public_path__ + "static/media/home.cf7e2639.svg";